import React from 'react';
import { Grid, List, ListItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { UnitCategoryCode, Fund, FundDocumentType } from 'funds-model';
import FundDetailsDialogAccordion from './FundDetailsDialogAccordion';
import { Title } from '../Title/Title';
import { useIsMobile } from '../utils/useIsMobile';
import { Link } from '../Link/Link';

import useStyles from './FundDetailsDialog.style';

export interface FundDetailsDialogDocumentsProps {
  fund: Fund;
  unitCategoryCode: UnitCategoryCode;
}

const DOCUMENT_URL_GET_FUND_CARD_FILE_ACTION_NAME = 'quotes.getFundCardFile';

const FundDetailsDialogDocuments: React.FC<FundDetailsDialogDocumentsProps> = ({ fund, unitCategoryCode }) => {
  const isMobile = useIsMobile();
  const c = useStyles({});
  const [t] = useTranslation('components');

  const documentsForUnitCode = fund.documentsForUnitCode[unitCategoryCode];
  const documentsForUnitCodeSorted = documentsForUnitCode
      ?.map(e => e)
      .sort((a, b) => a.seq - b.seq);

  if (!documentsForUnitCode || documentsForUnitCode.length === 0) {
    return null;
  }

  return (
    <FundDetailsDialogAccordion title={t('fund-details-dialog.documents')}>
      <Grid item>
        {!isMobile && <Title titleComponent="h3" titleVariant="h3" titleFontWeight="bold" title={t('fund-details-dialog.documents')}/>}
        <List disablePadding className={c.documentsListWrapper}>
          {documentsForUnitCodeSorted.map(document => {
            const shouldChangeUrl = document.typeCode === FundDocumentType.KARTY_FUNDUSZY && document.url.includes(DOCUMENT_URL_GET_FUND_CARD_FILE_ACTION_NAME);
            const documentUrl = shouldChangeUrl ? `${document.url}&unitCategoryId=${unitCategoryCode}` : document.url;
            return (
              <ListItem key={document.name}>
                <Link
                  as="link"
                  href={documentUrl}
                  target="_blank"
                  showDocumentIcon
                  showExternalIcon
                  testId="fund-document-link"
                >
                  {document.name}
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Grid>
    </FundDetailsDialogAccordion>
  );
};

export default FundDetailsDialogDocuments;
